(function () {
  function initStickyAtc(stickyRoot) {
    if (!stickyRoot || stickyRoot.dataset.stickyAtcInitialized === 'true') return;
    stickyRoot.dataset.stickyAtcInitialized = 'true';

    const stickyButton = stickyRoot.querySelector('[data-sticky-atc-button]');
    const stickyPrice = stickyRoot.querySelector('[data-sticky-atc-price]');
    const stickyImage = stickyRoot.querySelector('[data-sticky-atc-image]');
    const stickyVariants = stickyRoot.querySelector('[data-sticky-atc-variants]');
    const MOBILE_BP = 750;

    if (!stickyButton || !stickyPrice) return;

    const mainProductRoot =
      document.querySelector('[id^="MainProduct-"]') ||
      document.querySelector('.product__info-wrapper')?.closest('.page-width') ||
      document.querySelector('.product-page-container') ||
      document.body;

    let rafId = null;
    let rebindTimer = null;
    let intersectionObserver = null;
    let observedTargets = [];
    let targetFullyVisibleMap = new Map();
    let observerReady = false;
    let swatchStructureKey = '';
    let lastButtonHTML = '';
    let lastButtonClass = '';

    function isElementVisible(el) {
      if (!el) return false;
      const styles = window.getComputedStyle(el);
      if (styles.display === 'none' || styles.visibility === 'hidden') return false;
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    }

    function isFullyVisibleInViewport(el) {
      if (!el || !isElementVisible(el)) return false;

      const rect = el.getBoundingClientRect();
      const vw = window.innerWidth || document.documentElement.clientWidth;
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const tolerance = 1;

      return (
        rect.top >= 0 - tolerance &&
        rect.left >= 0 - tolerance &&
        rect.bottom <= vh + tolerance &&
        rect.right <= vw + tolerance
      );
    }

    function getMainAddButtons() {
      const selectors = [
        '.buy-bottoms__container button[name="add"]',
        'product-form button[name="add"]',
        'form[action*="/cart/add"] button[name="add"]'
      ];

      let buttons = [];
      selectors.forEach((selector) => {
        buttons = buttons.concat(Array.from(mainProductRoot.querySelectorAll(selector)));
      });

      buttons = Array.from(new Set(buttons));

      return buttons.filter((btn) => {
        if (!btn || stickyRoot.contains(btn)) return false;

        const quickAddZone = btn.closest('.quick-add, .card, .card-product, .featured-product, .product-grid');
        const insideMainProduct = !!btn.closest('[id^="MainProduct-"], .product__info-wrapper, product-info');

        if (quickAddZone && !insideMainProduct) return false;

        return mainProductRoot.contains(btn);
      });
    }

    function getReferenceButton() {
      const buttons = getMainAddButtons();
      if (!buttons.length) return null;
      const visibleButtons = buttons.filter(isElementVisible);
      return visibleButtons[0] || buttons[0];
    }

    function getObserverTargets() {
      const buttons = getMainAddButtons();
      const targets = [];

      buttons.forEach((btn) => {
        const target =
          btn.closest('.buy-bottoms__container') ||
          btn.closest('.product-form') ||
          btn.closest('.product-form__buttons') ||
          btn;

        if (target && !targets.includes(target)) {
          targets.push(target);
        }
      });

      return targets;
    }

    function isButtonUnavailable(btn) {
      if (!btn) return true;

      const text = (btn.textContent || '').toLowerCase();

      return (
        !!btn.disabled ||
        btn.getAttribute('aria-disabled') === 'true' ||
        text.includes('agotado') ||
        text.includes('sold out') ||
        text.includes('no disponible')
      );
    }

    function getVariantRadiosRoot() {
      return (
        mainProductRoot.querySelector('variant-radios') ||
        document.querySelector('variant-radios')
      );
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function getVariantFieldsets() {
      const radiosRoot = getVariantRadiosRoot();
      if (!radiosRoot) return [];
      return Array.from(radiosRoot.querySelectorAll('fieldset'));
    }

    function getVariantGroups() {
      const fieldsets = getVariantFieldsets();
      if (!fieldsets.length) return [];

      return fieldsets
        .map((fieldset, index) => {
          const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
          if (!inputs.length) return null;

          const legend = fieldset.querySelector('legend');
          const firstInput = inputs[0];
          const groupName =
            (legend && legend.textContent && legend.textContent.trim()) ||
            firstInput.getAttribute('name') ||
            `Opción ${index + 1}`;

          const items = inputs
            .map((input) => {
              const label = fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`);
              if (!label) return null;
              return { input, label };
            })
            .filter(Boolean);

          if (!items.length) return null;

          const isColorGroup = items.some(({ label }) => label.classList.contains('color-radio'));

          return {
            groupName,
            isColorGroup,
            items
          };
        })
        .filter(Boolean);
    }

    function renderVariantSwatches() {
      if (!stickyVariants) return;

      const groups = getVariantGroups();
      if (!groups.length) {
        if (stickyVariants.innerHTML !== '') stickyVariants.innerHTML = '';
        stickyVariants.hidden = true;
        swatchStructureKey = '';
        return;
      }

      const nextKey = groups
        .map((group) =>
          [
            group.groupName,
            group.isColorGroup ? 'color' : 'text',
            group.items
              .map(({ input, label }) =>
                [
                  input.id,
                  input.value || '',
                  input.checked ? '1' : '0',
                  input.disabled ? '1' : '0',
                  label.className || '',
                  label.getAttribute('style') || ''
                ].join('|')
              )
              .join('||')
          ].join('###')
        )
        .join('%%%%');

      if (nextKey === swatchStructureKey && stickyVariants.childElementCount) {
        stickyVariants.hidden = false;
        return;
      }

      swatchStructureKey = nextKey;

      const html = groups
        .map((group) => {
          const groupValuesHtml = group.items
            .map(({ input, label }) => {
              const styleAttr = label.getAttribute('style') || '';
              const isChecked = !!input.checked;
              const isDisabled =
                !!input.disabled ||
                label.classList.contains('disabled') ||
                label.getAttribute('aria-disabled') === 'true';

              const value = input.value || label.textContent?.trim() || 'Variante';
              const safeValue = escapeHtml(value);

              if (group.isColorGroup) {
                return `
                  <button
                    type="button"
                    class="sticky-atc__swatch${isChecked ? ' is-active' : ''}${isDisabled ? ' is-disabled' : ''}"
                    data-sticky-swatch
                    data-input-id="${escapeHtml(input.id)}"
                    aria-label="${safeValue}"
                    title="${safeValue}"
                    aria-pressed="${isChecked ? 'true' : 'false'}"
                    ${isDisabled ? 'disabled' : ''}
                    style="${styleAttr}"
                  >
                    <span class="sticky-atc__swatch-label">${safeValue}</span>
                  </button>
                `;
              }

              return `
                <button
                  type="button"
                  class="sticky-atc__variant-btn${isChecked ? ' is-active' : ''}${isDisabled ? ' is-disabled' : ''}"
                  data-sticky-swatch
                  data-input-id="${escapeHtml(input.id)}"
                  aria-label="${safeValue}"
                  title="${safeValue}"
                  aria-pressed="${isChecked ? 'true' : 'false'}"
                  ${isDisabled ? 'disabled' : ''}
                >
                  <span class="sticky-atc__variant-btn-label">${safeValue}</span>
                </button>
              `;
            })
            .join('');
          return `
            <div class="sticky-atc__variant-group${group.isColorGroup ? ' sticky-atc__variant-group--color' : ''}" data-sticky-variant-group>
              <span class="visually-hidden">${escapeHtml(group.groupName)}</span>
              <div class="sticky-atc__variant-group-values">
                ${groupValuesHtml}
              </div>
            </div>
          `;
        })
        .join('');

      stickyVariants.innerHTML = html;
      stickyVariants.hidden = false;
      syncVariantSwatchesState();
    }

    function syncVariantSwatchesState() {
      if (!stickyVariants || stickyVariants.hidden) return;

      const swatchButtons = Array.from(stickyVariants.querySelectorAll('[data-sticky-swatch]'));
      if (!swatchButtons.length) return;

      swatchButtons.forEach((btn) => {
        const inputId = btn.getAttribute('data-input-id');
        if (!inputId) return;

        const originalInput = document.getElementById(inputId);
        const originalLabel = originalInput
          ? originalInput.closest('fieldset')?.querySelector(`label[for="${CSS.escape(inputId)}"]`)
          : null;

        const checked = !!(originalInput && originalInput.checked);
        const disabled =
          !originalInput ||
          !!originalInput.disabled ||
          !!(originalLabel && (originalLabel.classList.contains('disabled') || originalLabel.getAttribute('aria-disabled') === 'true'));

        btn.classList.toggle('is-active', checked);
        btn.classList.toggle('is-disabled', disabled);
        btn.setAttribute('aria-pressed', checked ? 'true' : 'false');

        if (disabled) btn.setAttribute('disabled', 'disabled');
        else btn.removeAttribute('disabled');
      });
    }

    function selectOriginalVariantByInputId(inputId) {
      if (!inputId) return;

      const originalInput = document.getElementById(inputId);
      if (!originalInput || originalInput.disabled) return;

      const fieldset = originalInput.closest('fieldset');
      const originalLabel = fieldset
        ? fieldset.querySelector(`label[for="${CSS.escape(inputId)}"]`)
        : null;
      const lockX = window.scrollX;
      const lockY = window.scrollY;

      const restoreScroll = () => {
        window.scrollTo(lockX, lockY);
      };

      if (originalLabel) {
        originalLabel.click();
      } else {
        originalInput.click();
      }
      if (!originalInput.checked) {
        originalInput.checked = true;
      }
      originalInput.dispatchEvent(new Event('input', { bubbles: true }));
      originalInput.dispatchEvent(new Event('change', { bubbles: true }));

      try {
        if (typeof originalInput.blur === 'function') originalInput.blur();
      } catch (e) {}

      restoreScroll();
      requestAnimationFrame(restoreScroll);
      setTimeout(restoreScroll, 0);
      setTimeout(restoreScroll, 40);
      setTimeout(restoreScroll, 120);
      setTimeout(restoreScroll, 250);
      setTimeout(() => {
        scheduleUpdate();
        scheduleRebuildObserver();
      }, 30);
    }

    function syncButtonFromOriginal() {
      const originalBtn = getReferenceButton();

      if (!originalBtn) {
        stickyButton.disabled = true;
        return;
      }

      const nextClass = ['sticky-atc__button'].concat(Array.from(originalBtn.classList)).join(' ');
      if (lastButtonClass !== nextClass) {
        stickyButton.className = nextClass;
        lastButtonClass = nextClass;
      }

      const nextHTML = originalBtn.innerHTML;
      if (lastButtonHTML !== nextHTML) {
        stickyButton.innerHTML = nextHTML;
        lastButtonHTML = nextHTML;
      }

      stickyButton.disabled = isButtonUnavailable(originalBtn);

      if (originalBtn.hasAttribute('aria-label')) {
        stickyButton.setAttribute('aria-label', originalBtn.getAttribute('aria-label'));
      } else {
        stickyButton.removeAttribute('aria-label');
      }
    }

    function syncPriceFromOriginal() {
      const sourcePrice =
        mainProductRoot.querySelector('.price__block .price') ||
        mainProductRoot.querySelector('.price .price__container')?.closest('.price') ||
        mainProductRoot.querySelector('.price');

      if (!sourcePrice) return;

      const html = sourcePrice.outerHTML;
      if (stickyPrice.innerHTML !== html) {
        stickyPrice.innerHTML = html;
      }
    }

    function syncImageFromOriginal() {
      if (!stickyImage) return;

      const sourceImg =
        mainProductRoot.querySelector('.product__media-wrapper .product__media-item.is-active img') ||
        mainProductRoot.querySelector('.product__media-wrapper .media.is-active img') ||
        mainProductRoot.querySelector('.product__media-wrapper .media img') ||
        mainProductRoot.querySelector('.product__media-wrapper img');

      if (!sourceImg) return;

      const nextSrc = sourceImg.currentSrc || sourceImg.src;
      if (nextSrc && stickyImage.src !== nextSrc) {
        stickyImage.src = nextSrc;
      }

      const nextAlt = sourceImg.alt || stickyImage.alt;
      if (nextAlt && stickyImage.alt !== nextAlt) {
        stickyImage.alt = nextAlt;
      }
    }

    function getBottomObstructionOffset() {
      const isMobile = window.innerWidth < MOBILE_BP;
      let offset = parseInt(
        isMobile ? stickyRoot.dataset.mobileOffset || '12' : stickyRoot.dataset.desktopOffset || '16',
        10
      );

      const possibleFloatingSelectors = [
        '#hubspot-messages-iframe-container',
        '.zEWidget-launcher',
        '.intercom-lightweight-app',
        '.intercom-launcher',
        '.crisp-client',
        '.tawk-min-container',
        '.tidio-chat',
        'iframe[title*="chat"]',
        'iframe[src*="intercom"]',
        'iframe[src*="zendesk"]',
        'iframe[src*="tawk"]',
        'iframe[src*="tidio"]'
      ];

      possibleFloatingSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          try {
            const rect = el.getBoundingClientRect();
            const style = window.getComputedStyle(el);

            if (!rect.width || !rect.height) return;
            if (style.display === 'none' || style.visibility === 'hidden') return;
            if (style.position !== 'fixed') return;

            const nearBottom = rect.bottom > window.innerHeight - 180;
            if (!nearBottom) return;

            const obstructionHeight = Math.max(0, window.innerHeight - rect.top) + 12;
            offset = Math.max(offset, obstructionHeight);
          } catch (e) {}
        });
      });

      return offset;
    }

    function applyBottomOffset() {
      const offset = getBottomObstructionOffset();
      const nextValue = offset + 'px';
      if (stickyRoot.style.getPropertyValue('--sticky-atc-bottom-runtime') !== nextValue) {
        stickyRoot.style.setProperty('--sticky-atc-bottom-runtime', nextValue);
      }
    }

    function anyObservedTargetIsFullyVisible() {
      const visibleTargets = observedTargets.filter(isElementVisible);
      if (!visibleTargets.length) return false;
      return visibleTargets.some((target) => targetFullyVisibleMap.get(target) === true);
    }

    function updateVisibilityState() {
      const refBtn = getReferenceButton();

      if (!refBtn) {
        stickyRoot.classList.remove('is-active');
        return;
      }

      if (!observerReady) {
        stickyRoot.classList.remove('is-active');
        return;
      }
      if (!observedTargets.length) {
        stickyRoot.classList.remove('is-active');
        return;
      }

      const unavailable = isButtonUnavailable(refBtn);
      const originalAtcFullyVisible = anyObservedTargetIsFullyVisible();
      const shouldShow = !originalAtcFullyVisible && !unavailable;
      stickyRoot.classList.toggle('is-active', shouldShow);
    }

    function updateSticky() {
      syncButtonFromOriginal();
      syncPriceFromOriginal();
      syncImageFromOriginal();
      renderVariantSwatches();
      syncVariantSwatchesState();
      applyBottomOffset();
      updateVisibilityState();
    }

    function scheduleUpdate() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(function () {
        rafId = null;
        updateSticky();
      });
    }

    function rebuildIntersectionObserver() {
      if (intersectionObserver) {
        intersectionObserver.disconnect();
      }

      observerReady = false;
      targetFullyVisibleMap = new Map();
      observedTargets = getObserverTargets();

      if (!observedTargets.length) {
        observerReady = true;
        scheduleUpdate();
        return;
      }

      intersectionObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach((entry) => {
            const fullyVisible = entry.isIntersecting && entry.intersectionRatio >= 0.999;
            targetFullyVisibleMap.set(entry.target, fullyVisible);
          });

          observerReady = true;
          scheduleUpdate();
        },
        {
          root: null,
          threshold: [0, 1]
        }
      );

      observedTargets.forEach((target) => {
        targetFullyVisibleMap.set(target, isFullyVisibleInViewport(target));
        intersectionObserver.observe(target);
      });

      observerReady = true;
      scheduleUpdate();
    }

    function scheduleRebuildObserver() {
      clearTimeout(rebindTimer);
      rebindTimer = setTimeout(rebuildIntersectionObserver, 120);
    }

    function hasExternalMutations(mutations) {
      return mutations.some((mutation) => {
        const t = mutation.target;
        const el = t && t.nodeType === 1 ? t : t?.parentElement;
        if (el && stickyRoot.contains(el)) return false;
        return true;
      });
    }

    stickyButton.addEventListener('click', function (e) {
      e.preventDefault();

      const refBtn = getReferenceButton();
      if (!refBtn || isButtonUnavailable(refBtn)) return;

      refBtn.click();
    });

    if (stickyVariants) {
      stickyVariants.addEventListener('click', function (e) {
        const swatchBtn = e.target.closest('[data-sticky-swatch]');
        if (!swatchBtn) return;

        e.preventDefault();

        if (swatchBtn.disabled || swatchBtn.classList.contains('is-disabled')) return;

        const inputId = swatchBtn.getAttribute('data-input-id');
        selectOriginalVariantByInputId(inputId);
      });
    }

    window.addEventListener('resize', function () {
      scheduleRebuildObserver();
      scheduleUpdate();
    });

    document.addEventListener('variant:change', function () {
      scheduleUpdate();
      scheduleRebuildObserver();
    });

    document.addEventListener('variantChange', function () {
      scheduleUpdate();
      scheduleRebuildObserver();
    });

    document.addEventListener('change', function (e) {
      const target = e.target;
      if (!target) return;

      if (
        target.closest('variant-radios') ||
        target.closest('variant-selects') ||
        target.matches('select[name="id"]') ||
        target.matches('input[name="id"]')
      ) {
        scheduleUpdate();
        scheduleRebuildObserver();
      }
    });

    const mainObserver = new MutationObserver(function (mutations) {
      if (!hasExternalMutations(mutations)) return;
      scheduleUpdate();
      scheduleRebuildObserver();
    });

    mainObserver.observe(mainProductRoot, {
      subtree: true,
      childList: true,
      attributes: true,
      characterData: true
    });

    const bodyObserver = new MutationObserver(function (mutations) {
      if (!hasExternalMutations(mutations)) return;
      scheduleUpdate();
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    rebuildIntersectionObserver();
    setTimeout(scheduleUpdate, 300);
    setTimeout(scheduleRebuildObserver, 600);
    setTimeout(scheduleUpdate, 1000);
  }

  function initAllStickyAtc() {
    document.querySelectorAll('[data-sticky-atc]').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllStickyAtc);
  } else {
    initAllStickyAtc();
  }

  document.addEventListener('shopify:section:load', initAllStickyAtc);
})();